import { render, staticRenderFns } from "./message-audio-web.vue?vue&type=template&id=3e063c0e&scoped=true"
import script from "./message-audio-web.vue?vue&type=script&lang=ts"
export * from "./message-audio-web.vue?vue&type=script&lang=ts"
import style0 from "./message-audio-web.vue?vue&type=style&index=0&id=3e063c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e063c0e",
  null
  
)

export default component.exports